import axios from 'axios';

const API = '/api/kedo/v1';
const TOKEN_KEY = 'kedo_token';
const USER_KEY = 'kedo_user';

export function getKedoToken() {
    return localStorage.getItem(TOKEN_KEY);
}

export function setKedoSession({ token, user }) {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearKedoSession() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
}

export function getKedoUser() {
    try {
        return JSON.parse(localStorage.getItem(USER_KEY) || 'null');
    } catch {
        return null;
    }
}

function authHeaders() {
    const token = getKedoToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function kedoGet(path, config = {}) {
    const { data } = await axios.get(`${API}${path}`, {
        ...config,
        headers: { ...authHeaders(), ...(config.headers || {}) }
    });
    return data?.data;
}

export async function kedoPost(path, body, config = {}) {
    const { data } = await axios.post(`${API}${path}`, body, {
        ...config,
        headers: { ...authHeaders(), ...(config.headers || {}) }
    });
    return data?.data;
}

export async function kedoPut(path, body, config = {}) {
    const { data } = await axios.put(`${API}${path}`, body, {
        ...config,
        headers: { ...authHeaders(), ...(config.headers || {}) }
    });
    return data?.data;
}

export async function kedoRegister(payload) {
    const data = await kedoPost('/auth/register', payload);
    setKedoSession(data);
    return data;
}

export async function kedoLogin(payload) {
    const data = await kedoPost('/auth/login', payload);
    setKedoSession(data);
    return data;
}

export async function kedoUploadDocument(fields) {
    const form = new FormData();
    Object.entries(fields || {}).forEach(([k, v]) => {
        if (v === undefined || v === null) return;
        if (k === 'external_refs' && typeof v === 'object') {
            form.append(k, JSON.stringify(v));
            return;
        }
        form.append(k, v);
    });
    const { data } = await axios.post(`${API}/documents`, form, {
        headers: {
            ...authHeaders(),
            'Content-Type': 'multipart/form-data'
        }
    });
    return data?.data;
}

export { API as KEDO_API, TOKEN_KEY };
